import React from 'react';
var Box = function (_a) {
    var active = _a.active, _b = _a.deactivated, deactivated = _b === void 0 ? false : _b, link = _a.link, children = _a.children;
    var className = 'flex items-center justify-center w-10 h-10 mx-1 border border-solid rounded-lg';
    var addClass = function (classToAdd) { return className = className + " " + classToAdd; };
    if (deactivated) {
        addClass('cursor-not-allowed');
        addClass('border-gray-700 text-gray-700');
    }
    else if (active) {
        addClass('cursor-pointer');
        addClass('border-white text-white');
    }
    else {
        addClass('cursor-pointer');
        addClass('border-gray-700 text-gray-100 hover:border-white hover:text-white');
    }
    return (React.createElement("div", { className: className, onClick: link }, children));
};
var getArrowColor = function (disabled) {
    var dark = '#383D42';
    var light = '#EFF0F2';
    return disabled ? dark : light;
};
var SkipButtons = function (_a) {
    var index = _a.index, maxIndex = _a.maxIndex, nextLink = _a.nextLink, previousLink = _a.previousLink;
    var firstIndex = -1;
    var secondIndex = 0;
    var thirdIndex = -1;
    var leftArrowDisabled = false;
    var rightArrowDisabled = false;
    switch (index) {
        case 1:
            firstIndex = 1;
            secondIndex = 2;
            if (maxIndex > 2)
                thirdIndex = 3;
            leftArrowDisabled = true;
            break;
        case maxIndex:
            if (maxIndex > 2)
                firstIndex = index - 2;
            secondIndex = index - 1;
            thirdIndex = index;
            rightArrowDisabled = true;
            break;
        default:
            firstIndex = index - 1;
            secondIndex = index;
            thirdIndex = index + 1;
    }
    return (React.createElement("div", { className: "flex justify-center w-80" },
        React.createElement(Box, { deactivated: leftArrowDisabled, link: previousLink },
            React.createElement("svg", { width: "10", height: "17", viewBox: "0 0 10 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M8.5 15.5L1.5 8.5L8.5 1.5", stroke: getArrowColor(leftArrowDisabled), strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        firstIndex > -1 && React.createElement(Box, { active: index === firstIndex, link: previousLink }, firstIndex),
        React.createElement(Box, { active: index === secondIndex, link: leftArrowDisabled ? nextLink : rightArrowDisabled ? previousLink : undefined }, secondIndex),
        thirdIndex > -1 && React.createElement(Box, { active: index === thirdIndex, link: nextLink }, thirdIndex),
        React.createElement(Box, { deactivated: rightArrowDisabled, link: nextLink },
            React.createElement("svg", { width: "10", height: "17", viewBox: "0 0 10 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M1.5 1.5L8.5 8.5L1.5 15.5", stroke: getArrowColor(rightArrowDisabled), strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })))));
};
export default SkipButtons;
